import type ActivityFeedNotificationPayload from 'owa-service/lib/contract/ActivityFeedNotificationPayload';
import type { MailboxInfo } from 'owa-client-types';
import { action } from 'satcheljs';

export interface ACTIVITYFEED_NOTIFICATIONActionMessage {
    notification: ActivityFeedNotificationPayload;
    mailboxInfo: MailboxInfo | undefined;
}
const defaultExport: (
    notification: ActivityFeedNotificationPayload,
    mailboxInfo?: MailboxInfo
) => ACTIVITYFEED_NOTIFICATIONActionMessage = action(
    'ACTIVITYFEED_NOTIFICATION',
    (
        notification: ActivityFeedNotificationPayload,
        mailboxInfo?: MailboxInfo
    ): ACTIVITYFEED_NOTIFICATIONActionMessage => ({
        notification,
        mailboxInfo,
    })
);
export default defaultExport;
